export const convertCurrency = async (amount, toCurrency, fromCurrency = 'INR') => {
    try {
        const validAmount = amount && !isNaN(amount) ? amount : 1;
        if (!toCurrency) throw new Error('Target currency not specified');

        if (fromCurrency === toCurrency) {
            return validAmount;
        }

        const url = `https://api.frankfurter.app/latest?amount=${validAmount}&from=${fromCurrency}&to=${toCurrency}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`API error: ${response.statusText}`);

        const data = await response.json();
        const convertedAmount = data?.rates?.[toCurrency];

        if (convertedAmount === undefined) {
            throw new Error(`Conversion rate not found for ${toCurrency}`);
        }

        return convertedAmount;
    } catch (error) {
        console.error('Currency conversion error:', error.message);
        throw new Error('Failed to convert currency. Please try again.');
    }
};
